import { ECB, pkcs7Pad } from 'aes-js';

const POST_AES_KEY = 'SPtEFDewGjBeMxXxEEMWPkNcLWyjsPMy';

function stringToBytes(value) {
  return new TextEncoder().encode(value);
}

function bytesToBase64(bytes) {
  let binary = '';
  const chunkSize = 32768;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode(...chunk);
  }
  return btoa(binary);
}

export function encryptPostPayload(content) {
  const keyBytes = stringToBytes(POST_AES_KEY);
  const textBytes = stringToBytes(content);
  const padded = pkcs7Pad(textBytes);
  const aesEcb = new ECB(keyBytes);
  const encryptedBytes = aesEcb.encrypt(padded);
  return bytesToBase64(encryptedBytes);
}
